import BaseApi from './baseApi';
import IListStatusInbound from '../models/IListStatusInbound';
import IAuthentication from '../models/IAuthentication';
export default class ListStatusInboundsDeliveryNotesApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Settings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetListStatusInboundDeliveryNotes() : Promise<IListStatusInbound[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var listStatusInbound: IListStatusInbound[] = [];
            listStatusInbound = response.data as IListStatusInbound[];
            return listStatusInbound;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "ListStatusInboundsDeliveryNotes",
                "Item2": "id"
            }, {
                "Item1": "ListStatusInboundsDeliveryNotes",
                "Item2": "name"
            }, {
                "Item1": "ListStatusInboundsDeliveryNotes",
                "Item2": "isFinished"
            }],
            "tables": [{
                "Item1": "ListStatusInboundsDeliveryNotes"
            }],
            "conditions": [{
                "Item1": "ListStatusInboundsDeliveryNotes",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }],
            "orderBy": [{
                "Item1": "ListStatusInboundsDeliveryNotes.name"
            }]
        };
        return json;
    }
}
